var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Box, Stack, StepIcon, Typography } from '@mui/material';
import { RecordContextProvider, Button, useTranslate, } from 'react-admin';
import { useLocation, Link } from 'react-router-dom';
import RestoreIcon from '@mui/icons-material/Restore';
import pick from 'lodash/pick';
import { useGetRevisions } from '../dataProvider';
import { ReferenceRecordContextProvider } from '../ReferenceRecordContext';
import { detectChangedFields } from '../utils/detectChangedFields';
import { DropdownButton } from '../utils/DropdownButton';
import { DefaultDiffElement } from '../diff/DefaultDiffElement';
/**
 * Compare a given revision with all the other revisions of the same resource and record.
 */
export var RevisionDetails = function (props) {
    var revision = props.revision, _a = props.allowRevert, allowRevert = _a === void 0 ? false : _a, _b = props.renderName, renderName = _b === void 0 ? function (id) { return id; } : _b, _c = props.onRevert, onRevert = _c === void 0 ? defaultOnRevert : _c, _d = props.diff, diff = _d === void 0 ? defaultDiffElement : _d;
    var translate = useTranslate();
    var location = useLocation();
    var _e = React.useState(revision === null || revision === void 0 ? void 0 : revision.id), referenceRevisionId = _e[0], setReferenceRevisionId = _e[1];
    var revisions = useGetRevisions(revision === null || revision === void 0 ? void 0 : revision.resource, {
        recordId: revision === null || revision === void 0 ? void 0 : revision.recordId,
    }).data;
    React.useEffect(function () {
        if (!revision)
            return;
        setReferenceRevisionId(revision.id);
    }, [revision]);
    if (!revision || !revisions)
        return null;
    var lastRevision = revisions[0];
    var referenceRevisionIndex = revisions.findIndex(function (r) { return r.id === referenceRevisionId; });
    var referenceRevision = revisions[referenceRevisionIndex];
    var referenceRevisionData = referenceRevision === null || referenceRevision === void 0 ? void 0 : referenceRevision.data;
    var revisionIndex = revisions.findIndex(function (r) { return r.id === revision.id; });
    var revisionOptions = revisions.map(function (rev, index) { return ({
        id: rev.id,
        label: rev.id === revision.id
            ? translate('ra-history.revision_details.revision_selected', {
                _: 'Revision %{number} (selected)',
                number: revisions.length - index,
            })
            : translate('ra-history.revision_details.revision', {
                _: 'Revision %{number}',
                number: revisions.length - index,
            }),
    }); });
    var record = revisionIndex > referenceRevisionIndex
        ? referenceRevisionData
        : revision.data;
    var referenceRecord = revisionIndex > referenceRevisionIndex
        ? revision.data
        : referenceRevisionData;
    return (_jsxs(RecordContextProvider, { value: revision.data, children: [_jsxs(Stack, { direction: "row", spacing: 1, children: [_jsx(StepIcon, { icon: revisions.length - revisionIndex, sx: { mt: 1 } }), _jsxs(Box, { sx: {
                            flex: '1',
                            alignItems: 'flex-start',
                        }, children: [_jsx(Typography, { variant: "subtitle1", children: revision.message }), _jsxs(Typography, { variant: "caption", component: "div", gutterBottom: true, children: [new Date(revision.date).toLocaleString(), " -", ' ', revision.authorId && renderName(revision.authorId)] }), revision.description && (_jsx(Typography, { variant: "body2", gutterBottom: true, component: "pre", sx: { whiteSpace: 'pre-wrap' }, children: revision.description }))] }), revision.id !== lastRevision.id && allowRevert && (_jsx(Box, { children: _jsx(Button, { component: Link, to: __assign(__assign({}, location), { search: new URLSearchParams({
                                    _change: JSON.stringify(pick(revision.data, detectChangedFields(revision.data, lastRevision.data))),
                                }).toString() }), label: translate('ra-history.revision_details.revert', {
                                _: 'Revert to revision %{number}',
                                number: (revisions === null || revisions === void 0 ? void 0 : revisions.length) - revisionIndex,
                            }), onClick: onRevert, variant: "outlined", className: "revert-button", children: _jsx(RestoreIcon, {}) }) }))] }), revisions.length > 1 && (_jsx(DropdownButton, { label: revisionIndex !== referenceRevisionIndex
                    ? translate('ra-history.revision_details.compare', {
                        _: 'Compare with revision %{revision2}',
                        revision1: (revisions === null || revisions === void 0 ? void 0 : revisions.length) - revisionIndex,
                        revision2: (revisions === null || revisions === void 0 ? void 0 : revisions.length) -
                            referenceRevisionIndex,
                    })
                    : translate('ra-history.revision_details.compare_with', { _: 'Compare with...' }), selected: referenceRevisionId, setSelected: setReferenceRevisionId, options: revisionOptions, sx: { lineHeight: 1.5, opacity: 0.87, ml: -0.6, my: 1 } })), _jsx(RecordContextProvider, { value: record, children: _jsx(ReferenceRecordContextProvider, { value: referenceRecord, children: diff }) })] }));
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
var defaultOnRevert = function () { };
var defaultDiffElement = _jsx(DefaultDiffElement, {});
